export const areArraysEqualIgnoringOrder = <T>(
  a: readonly T[],
  b: readonly T[]
): boolean => {
  if (a.length !== b.length) return false;
  const aSorted = [...a].sort() as T[];
  const bSorted = [...b].sort() as T[];
  for (let i = 0; i < aSorted.length; i += 1) {
    if (aSorted[i] !== bSorted[i]) return false;
  }
  return true;
};

export const checkDirty = <T>(a: readonly T[], b: readonly T[]): boolean =>
  !areArraysEqualIgnoringOrder(a, b);
